<template>
    <div class="article-container" v-page-title="information.title">
        <div class="ql-snow">
            <div class="ql-editor" v-html="information.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Article",
        data() {
            return {
                information: {},
                informationId: '',
            }
        },
        async mounted() {
            this.informationId = this.$route.query.id;
            const { content } = await this.$http.get('/business/web/information/getById?id=' + this.informationId);
            if (content) {
                this.information = content;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .article-container {
        margin:35px auto 50px auto;
        padding: 20px 30px 24px 30px;
        width: 900px;
        min-height: 600px;
        background-color: white;
        border-radius: 3px 3px 3px 3px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }

</style>
